<div class="ni__dropdown-filter-wrapper relative" appClickOutside (clickOutSide)="closeDropdown()">
  <button type="button"
          class="secondary-dropdown-filter-btn"
          [ngClass]="isOpen ? 'open' : ''"
          (click)="toggleFilter()">
    <span>{{'filterBy'|translate}}</span>
    <svg-icon [key]="isOpen === true ? 'arrow-up' : 'arrow-down'" width="24px" height="24px"></svg-icon>
  </button>
  <ul class="ni__dropdown-filter" aria-labelledby="search-dropdown" *ngIf="isOpen">
    <li class="ni__dropdown-filter-item"
        *ngFor="let facet of narrowByFacets; let i = index">
      <div class="clickable-area" (click)="toggleFacet(i)">
        <span>{{facet.displayString}}</span>
        <svg-icon [key]="isFacetsOpen[i] === true ? 'arrow-up' : 'arrow-down'" width="24px" height="24px"></svg-icon>
      </div>
      <div class="ni__dropdown-filter__input-wrapper" *ngIf="facet.fieldName === 'manufacturer_fn' && isFacetsOpen[i]">
        <i class="fal fa-search"></i>
        <input type="text" [(ngModel)]="searchValue">
        <i class="fal fa-times" (click)="clearSearchValue()"></i>
      </div>
      <ul class="ni__sub-dropdown" *ngIf="isFacetsOpen[i]">
        <ng-container *ngFor="let subFacet of facet.facetValues">
          <li class="ni__sub-dropdown-item"
              *ngIf="getSearchValues(subFacet,facet)"
              (click)="filtering(subFacet)">
          <span [class.ni__selected-facet]="subFacet.selected">
            {{subFacet.displayString}}
          </span>
          </li>
        </ng-container>
      </ul>
    </li>

  </ul>
</div>
